import { render, staticRenderFns } from "./TuyenSinh2025.vue?vue&type=template&id=33cd4dba&"
import script from "./TuyenSinh2025.vue?vue&type=script&lang=js&"
export * from "./TuyenSinh2025.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports